import { all } from 'redux-saga/effects';

import { simpleRequestsLoader } from 'modules/app/utils';
import { CREATE_TEMPLATE_FROM_GROUP_REQUEST } from 'modules/groupTemplates/actionTypes';
import { redirectToCustomTemplateLink } from 'modules/templates/actions';

const simpleRequests = {
  [CREATE_TEMPLATE_FROM_GROUP_REQUEST]: {
    callbacks: {
      success: (data, meta, { payload }) => {
        const { locale: language, groupId } = payload;
        const templateId = data?.content?.[0]?.id;
        return redirectToCustomTemplateLink(templateId, { templateId, language, groupId }, meta);
      }
    },
    notifications: {
      success: undefined,
      failure: {
        id: 'group_config.create_template.failure',
        defaultMessage: 'An error occurred when creating the template',
      }
    }
  },
};

export default function* groupTemplatesSagas() {
  // Load simple requests
  yield all(simpleRequestsLoader(simpleRequests));
}
